import React from 'react'
import styles from './EfoPostalCode.module.css'
import type { City } from '../../../../../app/api/cityApi/types'
import { PREFECTURE_OPTION_GROUPS } from './prefectureOptions'

interface EfoAddressSelectsProps {
    prefectureId: number | null
    cityId: number | null
    cities: City[]
    citiesError: string
    isDisabled: boolean
    onPrefectureChange: (_prefectureId: number | null) => void
    onCityChange: (_cityId: number | null) => void
}

const toId = (value: string): number | null =>
    value === '' ? null : Number(value)

export const EfoAddressSelects = ({
    prefectureId,
    cityId,
    cities,
    citiesError,
    isDisabled,
    onPrefectureChange,
    onCityChange,
}: EfoAddressSelectsProps) => (
    <div className={styles.selectBox}>
        <label className={styles.selectLabel} htmlFor="efoPrefecture">
            都道府県
        </label>
        <select
            id="efoPrefecture"
            className={`${styles.select}${prefectureId ? ` ${styles.selected}` : ''}`}
            value={prefectureId ?? ''}
            disabled={isDisabled}
            onChange={e => onPrefectureChange(toId(e.target.value))}
        >
            {PREFECTURE_OPTION_GROUPS.map(group => (
                <optgroup key={group.region} label={group.region}>
                    {group.prefectures.map((prefecture, index) => (
                        <React.Fragment key={prefecture.id}>
                            {group.placeholderIndex === index && (
                                <option value="">選択してください</option>
                            )}
                            <option value={prefecture.id}>{prefecture.name}</option>
                        </React.Fragment>
                    ))}
                </optgroup>
            ))}
        </select>

        <label className={styles.selectLabel} htmlFor="efoCity">
            市区町村
        </label>
        <select
            id="efoCity"
            className={`${styles.select}${cityId ? ` ${styles.selected}` : ''}`}
            value={cityId ?? ''}
            disabled={isDisabled || cities.length === 0}
            onChange={e => onCityChange(toId(e.target.value))}
        >
            <option value="">選択してください</option>
            {cities.map(city => (
                <option key={city.id} value={city.id}>
                    {city.name}
                </option>
            ))}
        </select>
        {citiesError && <p className={styles.errorMessages}>{citiesError}</p>}
    </div>
)
